// Buckets of FleetHd.Case.CaseStatus, the internal status each tenant's case status maps to (CaseConfiguration).
// New sits in the lead row beside All Active / All Closed rather than under a header.
const NEW = 1;
const HEADED_BUCKETS: ReadonlyArray<{ labelKey: string; systemStatuses: readonly number[] }> = [
  { labelKey: '@open', systemStatuses: [2] },
  { labelKey: '@inProgress', systemStatuses: [3] },
  { labelKey: '@completed', systemStatuses: [4, 6] },
  { labelKey: '@cancelled', systemStatuses: [5] },
];

export interface CaseStatusGroup<T> {
  labelKey: string;
  statuses: T[];
  values: number[];
}

// Each group keeps the tenant's list order; unmapped or unknown internal statuses go last under Other.
export function groupCaseStatuses<T extends { value: number; systemStatus: number | null }>(statuses: readonly T[]): { lead: T[]; groups: CaseStatusGroup<T>[] } {
  const group = (labelKey: string, members: T[]): CaseStatusGroup<T> => ({ labelKey, statuses: members, values: members.map(s => s.value) });
  const lead = statuses.filter(s => s.systemStatus === NEW);
  const groups = HEADED_BUCKETS
    .map(bucket => group(bucket.labelKey, statuses.filter(s => s.systemStatus != null && bucket.systemStatuses.includes(s.systemStatus))))
    .filter(g => g.statuses.length > 0);
  const known = new Set<number>([NEW]);
  HEADED_BUCKETS.forEach(b => b.systemStatuses.forEach(s => known.add(s)));
  const other = statuses.filter(s => s.systemStatus == null || !known.has(s.systemStatus));
  return { lead, groups: other.length ? [...groups, group('@other', other)] : groups };
}
